import getClassStudents from '@/api/classes/getClassStudents.endPoint';
import getStudentsAssignedToATask from '@/api/teacher/tasks/getStudentsAssignedToATask.endpoint';
import useCustomHook from '@/hooks/useCustomHook';
import openAPIErrorNotification from '@/shared/APIErrorNotification/APIErrorNotification';
import { useEffect } from 'react';

export default function useTaskStudentsEditor({
  taskId,
  classId,
  selectedStudents,
  setSelectedStudents,
}) {
  const { state, actions } = useCustomHook({
    defaultState: {
      loading: true,
      classStudents: [],
    },
    actions: {
      loadClassStudents: async () => {
        try {
          actions.setState({
            loading: true,
          });
          if (taskId) {
            const taskStudents = await getStudentsAssignedToATask(taskId);
            setSelectedStudents(taskStudents);
          }
          const classStudents = await getClassStudents(classId);
          actions.setState({
            loading: false,
            classStudents,
          });
        } catch (e) {
          console.log(e);
          actions.setState({ loading: false });
          openAPIErrorNotification({
            title: 'There was an error',
            description:
              'There was a problem loading the students of this class',
            errorFeedback: e.feedbackData,
          });
        }
      },
      onStudentAdded: (selectedStudent) => {
        setSelectedStudents([...selectedStudents, selectedStudent]);
      },
      onStudentRemoved: (removedStudent) => {
        setSelectedStudents(
          selectedStudents.filter(
            (selectedStudent) => selectedStudent.id != removedStudent.id
          )
        );
      },
      selectAllStudents: () => {
        setSelectedStudents(state.classStudents);
      },
      unselectAllStudents: () => {
        setSelectedStudents([]);
      },
    },
  });

  useEffect(() => {
    if (classId) {
      actions.loadClassStudents();
    }
  }, [classId, taskId]);

  return { state, actions };
}
